angular.module('sharecrf.environment', ['study.i18n']);